module.exports = __webpack_public_path__ + "pc/img/swiper_03.d9b80784.jpg";